export const participantsApi = {
  participants: {
    queryKey: (params?: string[]) => ["participants", ...(params || [])],
    route: () => `participants`,
    exportRoute: () => `participants/export`,
    methods: ["GET", "POST"],
  },
  participant: {
    queryKey: (id: number, params?: string[]) => [
      "participants",
      id,
      ...(params || []),
    ],
    route: (id: number) => `participants/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
